import './FlowerBloom.css'

const PETAL_COUNT = 6

function Flower({ size = 160, delay = 0, stagger = 0.11, className = '' }) {
  return (
    <svg
      className={`flower-svg ${className}`}
      style={{ width: size, height: size, animationDelay: `${delay + PETAL_COUNT * stagger + 0.4}s` }}
      viewBox="0 0 200 200"
      aria-hidden="true"
    >
      <g transform="translate(100,100)">
        {Array.from({ length: PETAL_COUNT }).map((_, i) => (
          <g key={i} transform={`rotate(${(360 / PETAL_COUNT) * i})`}>
            <g className="petal-inner" style={{ animationDelay: `${delay + i * stagger}s` }}>
              <ellipse cx="0" cy="-42" rx="17" ry="40" className="petal-shape" />
            </g>
          </g>
        ))}
        <circle
          r="13"
          className="flower-center"
          style={{ animationDelay: `${delay + PETAL_COUNT * stagger}s` }}
        />
      </g>
    </svg>
  )
}
export default function FlowerBloom() {
  return (
    <div className="flower-bloom-layer" aria-hidden="true">
      <Flower size={190} delay={0.15} className="flower-tl" />
      <Flower size={150} delay={0.55} className="flower-br" />
      <Flower size={100} delay={0.9} className="flower-mid" />
    </div>
  )
}